import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IDataQualityAction } from '~src/spacesPlatform/models/actionNames';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { Messages } from '../../../codegen/Localize';
import { setCustomLabelAction } from '../../actions/labels/SetCustomLabelAction';
import { selectCatalogingOnSiteEnabled } from '../../selectors/CatalogSelectors';

export const SetCustomLabelEntityAction: IEntityAction<IContentInfo, IDataQualityAction> = {
    name: EntityActionNames.SetCustomDataLabel,
    translateName:Messages.editCustomLabelsAction,
    isVisible: (_, state) => selectCatalogingOnSiteEnabled(state),
    isClickable: (availableActions: IDataQualityAction) => !!(availableActions && availableActions.updateRemoveDataQuality),
    createReduxAction: (items) => {
        if (!items || items.length === 0 || items.length > 1) {
          throw new Error(Messages.setCustomDataLabelError());
        }
        return setCustomLabelAction(items[0]);
    }

};